// import "./main.css";
import App from "./App.svelte";
// import Placeholder from "./Placeholder.svelte";
new App({
  target: document.body,
});
